module.exports = __webpack_public_path__ + "static/media/data.2a84faba.csv";